import type { QueryParameterConfig } from '@pba/react-router';
import { type CreateReminderAction, isCreateReminderAction } from 'features/calendar';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const CreateReminderActionParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (isCreateReminderAction(value)) {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: CreateReminderAction) {
    return value;
  },
} satisfies QueryParameterConfig<CreateReminderAction | undefined>;
